const { h, render, Component } = require('preact');

class Gift extends Component {
  constructor() {
    super();
    this.getGiftElement = this.getGiftElement.bind(this);
  }

  getGiftElement(orderStatusInfo){
    if(orderStatusInfo.giftDeliveryMethod=='email')
      return <span>{I18n.translate('js.modules.support.email_gift')} {orderStatusInfo.giftRecipientName}</span>
    else
      return <span>{I18n.translate('js.modules.support.printed_gift')} {orderStatusInfo.giftRecipientName}</span>
  }

  getSentGiftTemplate(orderStatusInfo) {
    return (
      <div class={this.getClassName()}>
        <p>
          <span class="icon-gift"></span>
          {this.getGiftElement(orderStatusInfo)}
        </p>
      </div>
    )
  }

  getRecievedGiftTemplate(orderStatusInfo) {
    return(
      <div class={this.getClassName()}>
        <p>
          <span class="icon-gift"></span>
          {I18n.translate('js.modules.support.gift_from')} {orderStatusInfo.giftFromName}
        </p>
      </div>
    )
  }

  getClassName() {
    if (this.props.landingView)
      return "gift-info-landing"
    return "gift-info"
  }

  render({order}) {
    if(!order.status.giftInfo)
      return null

    let orderStatusInfo = order.status.giftInfo

    if(orderStatusInfo.isSentGift)
    {
      return this.getSentGiftTemplate(orderStatusInfo)
    }
    else if(orderStatusInfo.isReceivedGift)
    {
      return this.getRecievedGiftTemplate(orderStatusInfo)
    }
    else
    {
      orderStatusInfo = order.groupons[0]

      if(orderStatusInfo.giftFromName)
      {
        return this.getRecievedGiftTemplate(orderStatusInfo)
      } else
      {
        return this.getSentGiftTemplate(orderStatusInfo)
      }
    }

  }
}
module.exports = Gift
